<!--
 * @Description:  员工转正
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:32:37
-->
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card>
      <v-card-text>
        <!-- <v-row>
          <v-col cols="auto">
            <mrc_ess_switch v-model="list.staff_grade_status"
                            v-if="$store.state.uuid"
                            :true-value="1"
                            :false-value="0"
                            :readonly="disabled"
                            :true-text="$t('label_To_enable_the')"
                            :false-text="$t('label_disable')">
            </mrc_ess_switch>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_staticDom_m_key')"
              Required
              v-if="
                $store.state.sys_upload_type['file_upload_method'] === 'local'
              "
              :error-messages="$errors('list', 'attachment_key', requiredRule)"
              :isNational="judegNational('attachment_key')"
              v-model="list.attachment_key"
              :readonly="disabled"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_staticDom_m_describe')"
              noRequired
              :error-messages="
                $errors('list', 'attachment_description', requiredRule)
              "
              :isNational="judegNational('attachment_description')"
              v-model="list.attachment_description"
              :readonly="disabled"
            >
            </mrc_ess_multiText>
          </v-col>

          <v-col cols="12" v-if="viewFormDate.length <= 0">
            <mrc_ess_bulkFile
              v-model="file"
              fileTypeLabel="*"
              v-if="!disabled"
              @changeFile="changeFile"
            >
            </mrc_ess_bulkFile>
          </v-col>
          <v-col cols="12">
            <div
              v-for="(item, index) in viewFormDate"
              :key="index"
              class="d-flex justify-space-between align-center"
            >
              <div>
                <span class="mx-1">{{ item.file_name }}</span>
                <span>({{ (item.size / 1000000).toFixed(2) }}m)</span>
              </div>
              <div v-show="!disabled">
                <v-icon
                  class="material-icons mr-2"
                  @click="download(item, index)"
                  style="font-size: 24px"
                  >arrow_downward</v-icon
                >
                <v-icon
                  class="material-icons"
                  @click="deletefile(item, index)"
                  style="font-size: 24px"
                  >delete</v-icon
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        @cancel="cancel"
        :loading="btnIsLoading"
        v-if="!disabled"
      >
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { findSrc } from "@/service/api/upload.js";
import {
  static_resource_add,
  static_resource_edit,
  static_resource_detail,
  static_resource_delete,
} from "@/service/api/staticResource.js";
import { getBusinessList } from "@/service/api/prompt.js";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgUrl: "",
      file: [],
      viewFormDate: [],
      skeletonloading: true,
      dropDownList: [],
      list: {
        attachment_description: "",
        attachment_key: "",
      },
      btnIsLoading: false,
      viewList: {},
    };
  },
  computed: {},
  async created() {},
  watch: {},
  async mounted() {
    this.national("mrbase_sys_static_resource");
    if (this.$store.state.uuid) {
      await this.getDetail();
    } else {
    }
  },
  methods: {
    download(val, index) {
      const links = document.createElement("a");
      links.style.display = "none";
      //设置连接
      links.href = val.path;
      links.download = val.file_name;
      document.body.appendChild(links);
      //模拟点击事件
      links.click();
      document.body.removeChild(links);
    },
    deletefile(item, index) {
      this.viewFormDate.splice(index, 1);
    },
    async changeFile(v) {
      if (!this.list["resource_key"]) {
        //resource_key必填
        console.log("resource_key必填");
        return;
      }
      const res = await this.$uploadFiles([v], {
          module_uuid:'module',
          resource_key: this.list.attachment_key,
      });
      if (res && res.code == 200) {
        this.viewFormDate.push({
          ...res,
          path: res.url,
        });
      } else {
        this.$Message({
          text: this.$t("message_staticDom_m_uploadFailed"),
        });
      }
    },
    async getDetail() {
      this.skeletonloading = true;
      const res = await static_resource_detail({
        uuid: this.$store.state.uuid,
      });
      if (res.code == 200) {
        this.list = res.data;
        if (this.list.attachment_uuid) {
          let uuid_arr = this.list.attachment_uuid.split();
          uuid_arr.forEach((item) => {
            // + ',853d99f2-4398-4730-9c71-a2fdccfd958c'
            findSrc({ uuid: item }).then((res) => {
              // console.log(res, '888888888');
              this.viewFormDate = res.data.files;
            });
          });
        }
      } else {
      }
      this.skeletonloading = false;
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      let uuids = this.viewFormDate
        .map((item) => {
          return item.uuid;
        })
        .join();
      if (this.$store.state.uuid) {
        static_resource_edit({
          ...this.list,
          attachment_uuid: uuids,
        }).then(async (res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            await this.getDetail();
            this.$emit("changeReadonly");
          }
        });
      } else {
        static_resource_add({
          ...this.list,
          attachment_uuid: uuids,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            this.$router.push({ name: "staticResource" });
          }
        });
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "staticResource",
            });
          })
          .catch((err) => {});
      }
    },
  },
  validations: {
    list: {
      attachment_description: {
        required,
      },
      attachment_key: {
        required,
      },
    },
  },
};
</script>

<style scoped></style>
